import Content from "../content";
//import { BreadContext } from "../../../utils/context/breadcrum";
//import Breadcrum from "../../breadcrum";

function Main() {
  //const {ruta} = BreadContext();
   return (
     <>
       <div className="flex-1 min-h-screen h-screen w-full overflow-y-auto bg-white p-4 cursor-pointer select-none">
        
       <Content></Content>
       </div>
    </>
  );
}
export default Main;
